export default "__VITE_ASSET__CeG8ftOX__"